import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ICONES_BOTAO } from "../utils/icones";

/*
 * Modal para apresentar o texto completo que foi cortado na tela para não ocupar espaço.
 * preWrap: mantém as quebras de linha do texto (ex: comentário digitado com várias linhas)
 */
function ModalTexto({
  modalOpen,
  toggleModal,
  titulo,
  texto,
  preWrap = false,
  showFechar = true,
}) {
  return (
    <Modal isOpen={modalOpen} backdrop="static" size="lg" scrollable>
      <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
        {titulo || "Texto completo"}
      </ModalHeader>

      <ModalBody>
        {(texto && (
          <div
            className={`texto-leitura ${preWrap === true ? "texto-leitura-quebras" : ""}`}
          >
            {texto}
          </div>
        )) || (
          <div className="texto-leitura-vazio">Nenhum texto informado.</div>
        )}
      </ModalBody>

      {showFechar && (
        <ModalFooter>
          <Button name="btnFechar" color="secondary" onClick={toggleModal}>
            {ICONES_BOTAO.FECHAR} Fechar
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}

export default ModalTexto;
